<template>
  <div>
    <el-form-item label="内容">
      <el-input v-model="data.value" placeholder="请输入说明内容" type="textarea" :rows="14"></el-input>
    </el-form-item>
    <el-form-item label="背景颜色">
        <!--<el-color-picker v-model="data.color"></el-color-picker>-->
        <avue-color v-model="data.backgroundColor"></avue-color>
    </el-form-item>
    <el-form-item label="字体大小">
      <el-input v-model="data.fontSize" placeholder="请输入字体大小"></el-input>
    </el-form-item>
    <el-form-item label="行高">
      <el-input v-model="data.lineHeight" placeholder="请输入行高"></el-input>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'ConfigCaption',
  props: ['data'],
  data() {
    return {
      validator: {
        type: null,
        pattern: null,
        length: null
      }
    }
  },
  mounted() {
  },
  methods: {
    generateRule() {
      const rules = []
      Object.keys(this.validator).forEach(key => {
        if (this.validator[key]) rules.push(this.validator[key])
      })
      this.data.rules = rules
    }
  },
  watch: {

  }
}
</script>
